import React, { FunctionComponent } from "react";
import styles from "./ItemGroup.module.scss";
import { ItemGroupI } from "../../shared";
import cn from "classnames";

type ItemGroupProps = {
    itemGroup: ItemGroupI;
    onClick: () => void;
    small?: boolean;
};

const ItemGroup: FunctionComponent<ItemGroupProps> = ({ itemGroup, onClick, small }) => {
    return (
        <div onClick={onClick} className={cn(styles.container, small && styles.small)}>
            <img className={styles.img} src={itemGroup.PICTURE} />
            <span className={styles.name}>{itemGroup.NAME}</span>
        </div>
    );
};

export default ItemGroup;
